var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-form" },
    [
      _c("el-card", { staticClass: "form-card", attrs: { shadow: "hover" } }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("i", { staticClass: "el-icon-user" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.type === "add" ? "添加会员" : "编辑会员")),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-content" },
          [
            _c(
              "el-form",
              {
                ref: "formRef",
                attrs: {
                  model: _vm.formData,
                  rules: _vm.rules,
                  "label-width": "120px",
                },
              },
              [
                _c("div", { staticClass: "form-container" }, [
                  _c(
                    "div",
                    { staticClass: "left-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮件地址", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入邮件地址" },
                            model: {
                              value: _vm.formData.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "email", $$v)
                              },
                              expression: "formData.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "昵称", prop: "alias" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入昵称" },
                            model: {
                              value: _vm.formData.alias,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "alias", $$v)
                              },
                              expression: "formData.alias",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号", prop: "mobilePhone" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              placeholder: "请输入手机号",
                            },
                            model: {
                              value: _vm.formData.mobilePhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "mobilePhone", $$v)
                              },
                              expression: "formData.mobilePhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "出生日期", prop: "birthday" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              placeholder: "选择出生日期",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.birthday,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "birthday", $$v)
                              },
                              expression: "formData.birthday",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户头像" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: "#",
                                "show-file-list": false,
                                "before-upload": _vm.beforeAvatarUpload,
                                "on-change": _vm.handleAvatarChange,
                                "auto-upload": false,
                                disabled: _vm.avatarUploading,
                                "list-type": "picture-card",
                              },
                            },
                            [
                              _vm.formData.userpic && !_vm.avatarUploading
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.displayAvatarUrl },
                                  })
                                : _vm.avatarUploading
                                ? _c(
                                    "div",
                                    { staticClass: "avatar-uploading" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-loading",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "uploading-text" },
                                        [_vm._v("上传中...")]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "avatar-placeholder" },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员等级" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: "",
                                placeholder: "请选择会员等级",
                                loading: _vm.gradeLoading,
                                clearable: "",
                              },
                              model: {
                                value: _vm.formData.userRank,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "userRank", $$v)
                                },
                                expression: "formData.userRank",
                              },
                            },
                            _vm._l(_vm.vipGrades, function (grade) {
                              return _c("el-option", {
                                key: grade.id,
                                attrs: { label: grade.name, value: grade.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "radio-group",
                              model: {
                                value: _vm.formData.sex,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "sex", $$v)
                                },
                                expression: "formData.sex",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("男"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("女"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("保密"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "注册方式" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择注册方式",
                                clearable: "",
                              },
                              model: {
                                value: _vm.formData.registerType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "registerType", $$v)
                                },
                                expression: "formData.registerType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "系统注册", value: 0 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "点餐", value: 2 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "口碑", value: 3 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "社交", value: 4 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "支付宝", value: 5 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "测试用户" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "radio-group",
                              model: {
                                value: _vm.formData.isTest,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isTest", $$v)
                                },
                                expression: "formData.isTest",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-footer" },
              [
                _c("el-button", { on: { click: _vm.handleCancel } }, [
                  _vm._v("取消"),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit },
                  },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }